import React, {Component} from 'react';
import CONSTANTS from '../../config/constants'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronDoubleRight} from '@fortawesome/pro-regular-svg-icons';
import _ from "lodash";
import PublicForm from "../../../core/components/PublicForm";

class FormBlock extends Component {
    getContentFieldValue = (fieldDefinitionKey) => {
        const {contentFields} = this.props;
        const data = _.find(contentFields, {fieldDefinitionKey: fieldDefinitionKey});

        if (data) {
            try {
                return JSON.parse(data.data);
            } catch (e) {
                return data.data;
            }
        }
        return false
    };

    getBlockWidth = () => {
        const {width} = this.props;

        let w = 100;

        if (width && width !== CONSTANTS.BLOCK_DEFAULT_WIDTH) {
            return width;
        } else {
            if (this.getContentFieldValue('Width') && this.getContentFieldValue('Width') !== CONSTANTS.BLOCK_DEFAULT_WIDTH && this.getContentFieldValue('Width') !== w) {
                w = this.getContentFieldValue('Width');
            }
        }

        return w;
    };

    render() {

        const {id} = this.props;
        let url = null;

        if (this.getContentFieldValue('LinkToEvent') && this.getContentFieldValue('LinkToEvent').contentId) {
            url = `#/page/${this.getContentFieldValue('LinkToEvent')}`;
        }

        let target = "_self";

        if (this.getContentFieldValue('LinkToEvent') && this.getContentFieldValue('LinkToEvent').target) {
            target = "_blank";
        }

        const data = {
            title: this.getContentFieldValue('Title'),
            content: this.getContentFieldValue('Content'),
            linkText: this.getContentFieldValue('LinkToEvent') && this.getContentFieldValue('LinkToEvent').title ? this.getContentFieldValue('LinkToEvent').title : null,
            url: url,
            formStructure: this.getContentFieldValue('FormStructure')
        };

        return (
            <section className={"invitation w--" + this.getBlockWidth() + " show--shadow"}>
                <section className="invitation--inner">
                    <div className="content">
                        <h3>{data.title}</h3>
                        <div dangerouslySetInnerHTML={{__html: data.content}}>
                        </div>
                        <p>
                            <a target={target} href={data.url}>
                                {data.linkText} <FontAwesomeIcon icon={faChevronDoubleRight}/>
                            </a>
                        </p>
                    </div>
                    <PublicForm id={id} fields={data.formStructure.formFields} messages={data.formStructure.messages}/>
                </section>
            </section>
        );
    }
}

export default FormBlock;


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/FormBlock.js